<div class="p-3">
  <button
    class="btn btn-outline-secondary w-100 mb-2 d-flex align-items-center gap-3"
    (click)="languageService.toggleLang()"
  >
    <ng-container *ngIf="!isRtl">
      <img src="icons/uae-flag.svg" alt="uae flag" class="icon-svg" />
    </ng-container>
    <ng-container *ngIf="isRtl">
      <img
        src="icons/uk-flag.svg"
        alt="united-state-of-america flag"
        class="icon-svg"
        width="28"
        height="28"
      />
    </ng-container>
    <span class="fw-bolder">
      {{ !isRtl ? "العربية" : "English" }}
    </span>
  </button>

  <button
    class="btn btn-outline-secondary w-100 d-flex gap-3"
    (click)="logout()"
  >
    <img
      src="icons/logout.svg"
      alt="united-state-of-america flag"
      class="icon-svg"
    />

    {{ "dashboardLayout.logout" | translate }}
  </button>
</div>
